import { render, staticRenderFns } from "./app-skeleton.vue?vue&type=template&id=d8630ed4&scoped=true&"
import script from "./app-skeleton.vue?vue&type=script&lang=js&"
export * from "./app-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./app-skeleton.vue?vue&type=style&index=0&id=d8630ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8630ed4",
  null
  
)

export default component.exports